import React, { ReactNode } from "react";
import { useTheme, Theme } from "@mui/material/styles";
import { Box } from "@mui/material";
import Header from "./Header";
import Footer from "./Footer";

interface IProps {
  children?: ReactNode;
  headerTitle?: string
}

const AppContainer : React.FC<IProps> = ({ children, headerTitle }) => {
  const theme: Theme = useTheme();
  return  (
    <Box
      display="flex"
      flexDirection="column"
      minHeight="100vh"
      style={{ backgroundColor: theme.palette.background.default }}
    >
      <Header title={headerTitle || ''} />
      <Box
        flex={1}
        display="flex"
        flexDirection="column"
        justifyContent="start"
        alignItems="center"
        sx={{ justifyContent: "center", position: "relative" }}
      >
        {children}
      </Box>
      <Footer />
    </Box>
  );
};

export default AppContainer;
